export default __webpack_public_path__ + "static/cards-de@2x-6d8f47cf47c39fb7a91f7df09735bef6.png";